import { Briefcase, ExternalLink, MapPin } from "lucide-react";
import { buildJobSearch } from "@/lib/jobs";

export function JobLinks({ profile }) {
  const search = buildJobSearch(profile);

  return (
    <section className="mt-12" data-testid="job-links-section">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
        <div className="flex items-start gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-[#0F172A] text-white">
            <Briefcase className="h-5 w-5" />
          </span>
          <div>
            <h2 className="font-heading text-2xl font-bold text-slate-900">Job opportunities</h2>
            <p className="mt-1 text-sm text-slate-600">
              Many PNP streams reward a Canadian job offer. These searches are pre-filtered to your profile so you can
              start looking right away.
            </p>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap items-center gap-2 text-sm">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 font-medium text-slate-700">
            <Briefcase className="h-3.5 w-3.5 text-slate-400" />
            {search.title ? search.title : `${search.teerLabel}`}
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 font-medium text-slate-700">
            <MapPin className="h-3.5 w-3.5 text-slate-400" />
            {search.provName || "All of Canada"}
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 font-medium text-slate-700">
            {search.totalExp} yr experience
          </span>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {search.links.map((l) => (
            <a
              key={l.id}
              href={l.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`job-link-${l.id}`}
              className="group flex flex-col rounded-xl border border-slate-200 bg-slate-50/60 p-5 transition-all hover:-translate-y-0.5 hover:border-[#C8102E]/40 hover:bg-white hover:shadow-md"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading font-semibold text-slate-900">{l.name}</span>
                <ExternalLink className="h-4 w-4 text-slate-400 transition-colors group-hover:text-[#C8102E]" />
              </div>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{l.desc}</p>
              <span className="mt-4 text-xs font-semibold text-[#C8102E]">Search {search.provName || "Canada"} →</span>
            </a>
          ))}
        </div>

        <p className="mt-5 text-xs text-slate-500">
          {profile.occupationTitle
            ? "Tip: refine the job title on your profile to sharpen these results."
            : "Tip: add your job title on the profile's Work step to make these searches far more relevant."}
        </p>
      </div>
    </section>
  );
}
